export default `
  mutation addAdminNote($userId: ID!, $content: String!, $type: String) {
    addAdminNote(userId: $userId, content: $content, type: $type) {
      id
      adminNotes {
        id
        type
        content
        author
        createdAt
      }
    }
  }
`
